<template>
  <DandisetsPage title="Public Dandisets" />
</template>

<script>
import DandisetsPage from '@/components/DandisetsPage.vue';

export default {
  name: 'PublicDandisetsView',
  components: { DandisetsPage },
};
</script>
